
/**
 * Zoom in on image
 *
 * config accepts:
 *
 * min_width - minimum screen width required to use zoom
 *
 * @constructor
 * @param {Object} $imgContainer
 * @param {Object} config
 */
function ImageZoom($imgContainer, config) {
	'use strict';
	this.$imgContainer = $imgContainer;
	this.config = config || {};
	this.initialized = false;
}

ImageZoom.prototype = {

	/**
	 * Zoom wrapper Options:
	 *
	 *
	 * url	false	The url of the large photo to be displayed. If no url, use $imgContainer img
	 * on	'mouseover'	The type of event that triggers zooming. Choose from mouseover, grab, click, or toggle.
	 * duration	120	The fadeIn/fadeOut speed of the large image.
	 * target	false	A selector or DOM element that should be used as the parent container for the zoomed image.
	 * touch	true	Enables interaction via touch events.
	 * magnify	1	This value is multiplied against the full size of the zoomed image.
	 * callback	false	A function to be called when the image has loaded.
	 * onZoomIn	false	A function to be called when the image has zoomed in.
	 * onZoomOut false
	 *
	 *
	 * @param  {Object} options
	 * @return {ImageZoom}
	 */
	init : function (options) {
		'use strict';

		this.$target = $(options.target).hide();

		//cache incase we don't use now, but need later
		this.zoomOptions = options;
		this.zoomOptions.onZoomIn = () => {
			this.$target.show();
		};
		this.zoomOptions.onZoomOut = () => {
			this.$target.hide();
		};

		if (this.config['min_width']) {

			//cache for later
			this.minWidth = this.config['min_width'];
			this.bindWindowResize();

			if (!this.suffcientWidth()) {
				return;
			}
		}

		this.initZoom();
	},

	initZoom: function () {
		'use strict';

		if (this.$imgContainer.zoom) {
			this.$imgContainer.zoom(this.zoomOptions);
			this.setInitialized(true);
		}
	},

	/**
	 * @return {Boolean}
	 */
	suffcientWidth: function () {
		'use strict';
		return this.getCurrentWidth() >= this.minWidth;
	},

	/**
	 * Get current viewport width
	 * @return {Number}
	 */
	getCurrentWidth: function () {
		'use strict';

		return window.innerWidth;
	},

	/**
	 * Bind handler to window resize event
	 */
	bindWindowResize: function () {
		'use strict';

		$(window).on('resize', $.proxy(this.handleWindowResize, this));
	},

	/**
	 * Handle resizing of window
	 * @return {mixed}
	 */
	handleWindowResize: function () {
		'use strict';

		//Screen is large enough
		if (this.suffcientWidth()) {

			//Already intialised
			if (this.initialized) {
				return;
			}

			return this.initZoom();
		}

		//remove previous initialization
		if (this.initialized) {
			this.destroy();
		}

	},

	/**
	 * Remove functionality
	 */
	destroy: function () {
		'use strict';
		this.$imgContainer.trigger('zoom.destroy');
		this.setInitialized(false);
	},

	/**
	 * Set status of initialization
	 * @param {Boolean} initialized
	 */
	setInitialized: function (initialized) {
		'use strict';

		this.initialized = initialized;
	}
};

export default ImageZoom;